import RecipeDeclined from "./RecipeDeclined";

export default RecipeDeclined;
